// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"474ac53f","537":"2846443f"}[chunkId] + ".chunk.js";
};